// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2rPui","header":"PatientBlock_header__1GMhe","label":"PatientBlock_label__1uXb6","option":"PatientBlock_option__3TrA2"};